import { Box, HStack, Icon, Spacer, Text, VStack } from '@chakra-ui/react';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/all';
import React, { useCallback } from 'react';
import { Flex } from '@chakra-ui/layout';

export interface StepperProps {
  title?: string;
  hint?: string;
  handleChange: (name: string, value: number, type: StepperOperator) => void;
  name: any;
  value: number;
  defaultValue?: number;
  minimumValue?: number;
  maximumValue?: number;
  boxSize: number;
}
export enum StepperOperator {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT',
}
export const Stepper = (props: StepperProps): JSX.Element => {
  const { title, hint, handleChange, name, value, minimumValue, maximumValue, boxSize } = props;

  const handleIncrement = useCallback(() => {
    if (typeof maximumValue === 'number' && value < maximumValue) {
      handleChange(name, value, StepperOperator.INCREMENT);
    } else if (typeof maximumValue === 'undefined') {
      handleChange(name, value, StepperOperator.INCREMENT);
    }
  }, [name, value, handleChange]);

  const handleDecrement = useCallback(() => {
    if (typeof minimumValue === 'number' && value > minimumValue) {
      handleChange(name, value, StepperOperator.DECREMENT);
    } else if (typeof minimumValue === 'undefined') {
      handleChange(name, value, StepperOperator.DECREMENT);
    }
  }, [name, value, handleChange, minimumValue]);

  return (
    <Flex w={'100%'}>
      {title && (
        <VStack flex={1} spacing={0} alignItems={'flex-start'}>
          <Text userSelect={'none'}>{title}</Text>
          {hint && <Text textStyle={'chakraSelect.menuList.addSubItem.hint'}>{hint}</Text>}
        </VStack>
      )}

      <HStack alignItems={'center'}>
        <Icon
          boxSize={boxSize}
          onClick={handleDecrement}
          color={value === minimumValue ? 'gray.100' : 'blue.400'}
          _hover={{
            color: value === minimumValue ? 'gray.100' : 'blue.700',
            cursor: value === minimumValue ? 'default' : 'pointer',
          }}
          as={AiOutlineMinusCircle}
          mr={2}
        />
        <Box userSelect={'none'} w={8} textAlign={'center'}>
          <Text>{value}</Text>
        </Box>
        <Icon
          boxSize={boxSize}
          onClick={handleIncrement}
          color={value === maximumValue ? 'gray.100' : 'blue.400'}
          _hover={{
            color: value === maximumValue ? 'gray.100' : 'blue.700',
            cursor: value === maximumValue ? 'default' : 'pointer',
          }}
          as={AiOutlinePlusCircle}
          ml={2}
        />
      </HStack>
    </Flex>
  );
};
